<template>
  <div class="sso-login">
    <div v-if="fail">SSO 登录失败..</div>
    <div v-else-if="success">SSO 登录成功，{{ countdown }} 秒后跳转到工作台...</div>
    <div v-else>SSO 登录中...</div>
  </div>
</template>

<script lang="ts" setup>
import { getOAuthAuthorizeConfig, postCheckToken, postOAuthLogin } from '@/api/module/oauth';
import { COOKIE_KEY } from '~/constants/config';

const fail = ref(!!getQueryString('fail'));
const success = ref(false);
const countdown = ref(3);

const permissionData = usePermissionData();
const { setSession, setUserInfo } = useChangeUser();

let countdownTimer: NodeJS.Timeout | null = null;

const onLoginSuccess = async (login_data: any) => {
  // 用户token
  setSession(login_data);

  emitBroadcast(COOKIE_KEY.USER_TOKEN, {
    cookieValue: login_data,
  });

  success.value = true;
  startCountdown();
};

const startCountdown = () => {
  countdown.value = 3;
  countdownTimer = setInterval(() => {
    countdown.value--;
    if (countdown.value <= 0) {
      clearInterval(countdownTimer!);
      countdownTimer = null;
      window.location.href = `${location.origin}/workspace/`;
    }
  }, 1000);
};

onUnmounted(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer);
    countdownTimer = null;
  }
});

onMounted(async () => {
  // 通过是否存在 code 判断当前是登录行为还是交还凭证的阶段
  const code = getQueryString('code');
  const service = getQueryString('service');
  if (code) {
    // 获取 url 所有的 query 参数
    const queryParams = new URLSearchParams(window.location.search);
    const query = Object.fromEntries(queryParams.entries());
    try {
      const res = await postOAuthLogin({
        ...query,
        service,
      });
      const login_data = res.data?.[0];
      if (login_data) {
        onLoginSuccess(login_data);
      } else {
        throw new Error('登录失败');
      }
    } catch (err) {
      message.error('登录失败');
      fail.value = true;
    }

    return;
  }

  if (service) {
    try {
      await postCheckToken(service);
      success.value = true;
      startCountdown();
    } catch (err) {
      const res = await getOAuthAuthorizeConfig(service);
      const redirect_url = res.data.redirect_url;
      if (redirect_url) {
        location.replace(redirect_url);
      } else {
        throw new Error('redirect_url 为空');
      }
      message.error('登录失败: token 已失效');
      fail.value = true;
    }
  }
});
</script>

<style lang="scss" scoped>
.sso-login {
  @apply h-full flex items-center justify-center;
  height: 100vh;
  width: 100vw;
}
</style>
